import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
// import moment from "moment";
import Form from "../../components/common/form";
import { getPayment, getPaymentNav, savePayment, getPaymentOptions, verifyPayment } from "../../services/paymentService";
import { getCustomer } from "../../services/customerService";
import { getCustomerAccounts, getAccount } from "../../services/accountService";
import { getServices, getService } from "../../services/servicesService";
import { getEmployees } from "../../services/employeeService";
import { getEligiblePromotions } from "../../services/promotionService";
import {
  getWallet,
  renewAccountWithCredit,
} from "../../services/portalRenewalService";
import RecordNavigation from "../../components/common/recordNavigation";
import Payment360Panel from "./payment360/Payment360Panel";
import CustomerPaymentModal from "../../components/payment/CustomerPaymentModal";

class PaymentForm extends Form {
  state = {
    title: "Transaction",
    loadingRecord: true,
    viewMode: "workspace",
    data: {
      customer: "0",
      account: "0",
      createdby: "0",
      confirmedby: "0",
      service: "0",
      quantity: "0",
      unitprice: "0",
      amount: "0",
      comment: "",
      transid: "",
      fullname: "0",
      phone: "0",
      mobile: "0",
      email: " ",
      address: "0",
      city: "0",
      state: "0",
      country: "0",
      invnum: "",
      paymode: "0",
      status: "0",
      paid: "",
      remark: "",
    },
    boolean: [
      { id: 1, label: "True", value: true },
      { id: 2, label: "False", value: false }
    ],
    paymode: [
      { id: 1, label: "Cash", value: 1 },
      { id: 2, label: "Bank", value: 2 },
      { id: 3, label: "Credit", value: 3 },
      { id: 4, label: "Online", value: 4 },
    ],
    availableCredit: 0,
    selfAllocateEnabled: false,
    renewingWithCredit: false,
    selectedAccountId: null,
    // FIXME: Move status to centralized location
    status: [
      { id: 0, label: "New", value: 0 },
      { id: 1, label: "Paid", value: 1 },
      { id: 2, label: "Completed", value: 2 },
      { id: 3, label: "Canceled", value: 3 },
    ],
    countryList: [
      { id: 1, label: "Nigeria", value: "Nigeria" }
    ],
    stateList: [
      { id: 1, label: "Abia", value: "AB" },
      { id: 2, label: "Adamawa", value: "AD" },
      { id: 3, label: "Akwa Ibom", value: "AK" },
      { id: 4, label: "Anambra", value: "AN" },
      { id: 5, label: "Bauchi", value: "BA" },
      { id: 6, label: "Bayelsa", value: "BY" },
      { id: 7, label: "Benue", value: "BE" },
      { id: 8, label: "Borno", value: "BO" },
      { id: 9, label: "Cross River", value: "CR" },
      { id: 10, label: "Delta", value: "DE" },
      { id: 11, label: "Ebonyi", value: "EB" },
      { id: 12, label: "Edo", value: "ED" },
      { id: 13, label: "Ekiti", value: "EK" },
      { id: 14, label: "Enugu", value: "EN" },
      { id: 15, label: "Federal Capital Territory", value: "FC" },
      { id: 16, label: "Gombe", value: "GO" },
      { id: 17, label: "Imo", value: "IM" },
      { id: 18, label: "Jigawa", value: "JI" },
      { id: 19, label: "Kaduna", value: "KD" },
      { id: 20, label: "Kano", value: "KN" },
      { id: 21, label: "Katsina", value: "KT" },
      { id: 22, label: "Kebbi", value: "KE" },
      { id: 23, label: "Kogi", value: "KO" },
      { id: 24, label: "Kwara", value: "KW" },
      { id: 25, label: "Lagos", value: "LA" },
      { id: 26, label: "Nasarawa", value: "NA" },
      { id: 27, label: "Niger", value: "NI" },
      { id: 28, label: "Ogun", value: "OG" },
      { id: 29, label: "Ondo", value: "ON" },
      { id: 30, label: "Osun", value: "OS" },
      { id: 31, label: "Oyo", value: "OY" },
      { id: 32, label: "Plateau", value: "PL" },
      { id: 33, label: "Rivers", value: "RI" },
      { id: 34, label: "Sokoto", value: "SO" },
      { id: 35, label: "Taraba", value: "TA" },
      { id: 36, label: "Yobe", value: "YO" },
      { id: 37, label: "Zamfara", value: "ZA" },
    ],
    customerList: [],
    customer: {},
    customerAccountList: [],
    serviceList: [],
    employeeList: [],
    errors: {},
    providerPublicKey: '',
    paymentOptions: [],
    providerKey: '',
    promotionPreview: null,
    navPaths: [],
    filters: null,
    paymentModalOpen: false,
  };

  isUnsetValue = value => value === undefined || value === null || value === "" || value === "0" || value === 0;

  doRequeryTransaction = async () => {
    const reference = this.state.data?.transid;
    if (!reference) {
      toast.error("No transaction reference found");
      return;
    }

    const confirmSync = window.confirm("Are you sure you want to sync this payment with the selected provider?");
    if (!confirmSync) return;

    try {
      toast.info(`Syncing payment ${reference}...`);
      
      const response = await verifyPayment({ reference });
      
      const updatedData = await this.populateTransaction();
      
      // Handle different response scenarios with new idempotent behavior
      if (response && response.data && response.data.verified) {
        if (response.data.alreadyVerified) {
          toast.info(`Payment ${reference} is already verified and up to date`);
        } else if (updatedData && updatedData.paid) {
          toast.success(`Payment ${reference} synced! Account updated.`);
        } else if (updatedData && updatedData.status === '1') {
          toast.success(`Transaction ${reference} synced successfully`);
        } else {
          toast.info(`Transaction ${reference} synced - no status change`);
        }
      } else {
        const message = response?.data?.message || 'Transaction verification failed';
        toast.info(`Payment ${reference}: ${message}`);
      }
    } catch (ex) {
      console.error('Error syncing transaction:', ex);
      
      // Handle specific error messages
      if (ex.response && ex.response.data) {
        const errorMessage = ex.response.data;
        if (errorMessage.includes('already been verified') || errorMessage.includes('already verified')) {
          toast.info(`Payment ${reference} is already verified and up to date`);
        } else {
          toast.error(`Failed to sync payment ${reference || ''}: ${errorMessage}`);
        }
      } else {
        toast.error(`Failed to sync payment ${reference || ''}: ${ex.message || 'Unknown error'}`);
      }
    }
  };

  searchServices = async (term) => {
    try {
      const response = await getServices({ page: 1, pageSize: 50, search: term, sortBy: 'name', sortOrder: 'ASC' });
      const payload = response?.data;
      const services = Array.isArray(payload) ? payload : (payload?.data || []);

      const serviceList = services.map(service => ({
        id: service.id,
        label: service.name,
        value: service.id,
      }));

      this.setState({ serviceList });
    } catch (error) {
      console.error('Error searching services:', error);
      this.setState({ serviceList: [] });
    }
  };

  async populateNavigationPaths() {
    try {
      const filters = this.props.location?.state?.filters;
      if (!filters) {
        const navPaths = this.props.location?.state?.nav?.paths || [];
        this.setState({ navPaths });
        return;
      }

      const params = {
        page: 1,
        pageSize: 1000,
        sortBy: filters.sortColumn?.path || 'id',
        sortOrder: filters.sortColumn?.order || 'desc',
      };
      if (filters.searchQuery) params.search = filters.searchQuery;

      const response = await getPaymentNav(params);
      const payments = response?.data?.data || [];
      const navPaths = payments.map(p => `/payments/${p.transid}`);
      this.setState({ navPaths, filters });
    } catch (error) {
      console.error('Error fetching payment navigation paths:', error);
      const navPaths = this.props.location?.state?.nav?.paths || [];
      this.setState({ navPaths });
    }
  }

  schema = {
    id: Joi.any(),
    createdby: Joi.any(),
    confirmedby: Joi.any(),
    comment: Joi.any(),
    transid: Joi.any(),
    fullname: Joi.any(),
    phone: Joi.any(),
    mobile: Joi.any(),
    address: Joi.any(),
    city: Joi.any(),
    state: Joi.any(),
    country: Joi.any(),
    invnum: Joi.any(),
    paymode: Joi.any(),
    status: Joi.any(),
    paid: Joi.any(),
    remark: Joi.any(),
    customer: Joi.number().integer().required(),
    account: Joi.string().min(1).max(50).required(),
    email: Joi.string().min(5).max(255).required().email(),
    service: Joi.number().integer().required(),
    quantity: Joi.number().integer().min(1).required(),
    unitprice: Joi.number().integer().required(),
    amount: Joi.number().min(0).required()
  };

  async populateTransaction() {
    let title = "";
    try {
      this.setState({ loadingRecord: true });

      const paymentId = this.props.match.params.id;

      if (paymentId === "new") {
        title = "New Transaction";
        this.setState({ title: title, loadingRecord: false, viewMode: "edit" });


        let data = { ...this.state.data };
        data['createdby'] = this.props.user.id;
        data['customer'] = this.props.user.id;
        this.setState({ data });
      }
      else {
        const { data: payment } = await getPayment(paymentId);
        const data = this.mapToViewModel(payment);

        // Extract subaccount code and split details from reseller if available
        if (payment.Reseller && payment.Reseller.paystack_subaccount_code) {
          data.subaccountCode = payment.Reseller.paystack_subaccount_code;
          data.splitType = payment.Reseller.split_type;
          data.splitAmount = payment.Reseller.split_amount;
        }

        const serviceList = [];
        if (data.service) {
          try {
            const { data: service } = await getService(data.service);
            const label = service?.name || String(data.service);
            serviceList.push({ id: data.service, label, value: data.service });
          } catch (e) {
            serviceList.push({ id: data.service, label: String(data.service), value: data.service });
          }
        }

        this.setState({ data, serviceList });

        if (this.state.data.transid) { (title = "Process Transaction") }
        if (this.state.data.invnum) { (title = "View Transaction") }
        this.setState({ title: title, loadingRecord: false, viewMode: "workspace" });
      }

    } catch (ex) {
      this.setState({ loadingRecord: false });
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }


  async populateServiceList() {
    return;
  };

  // async populateCustomerList() {
  //   let { data: customers } = await getCustomers();

  //   customers = [customers];
  //   const customerList = customers.map(customer => {
  //     const customerlist = {};
  //     customerlist['id'] = customer.id;
  //     customerlist['label'] = customer.name;
  //     customerlist['value'] = customer.id;
  //     return customerlist;
  //   })

  //   this.setState({ customerList });
  // };

  async populateCustomer() {
    let { data: customer } = await getCustomer();

    this.setState({ customer });
  };

  async populateEmployeeList() {
    const { data: employees } = await getEmployees();

    const employeeList = employees.map(employee => {
      const employeelist = {};
      employeelist['id'] = employee.id;
      employeelist['label'] = employee.name;
      employeelist['value'] = employee.id;
      return employeelist;
    })
    this.setState({ employeeList });
  }

    
  async populatePaymentOptions() {
    const response = await getPaymentOptions();
    const options = response.data?.data || [];
    const providerKey = this.state.data.providerKey || options[0]?.providerKey || '';
    this.setState({ paymentOptions: options, providerKey, providerPublicKey: options.find((option) => option.providerKey === providerKey)?.publicKey || '' });
  }

  async componentDidMount() {
    // await this.populateCustomer()
    await this.populateCustomerAccountList();
    await this.populateTransaction();
    await this.populatePaymentOptions();
    await this.populateWallet();

    await this.populateNavigationPaths();
  }

  async populateWallet() {
    try {
      const { data: payload } = await getWallet();
      const wallet = payload?.data || payload || {};
      this.setState({
        availableCredit: Number(wallet.availableCredit) || 0,
        selfAllocateEnabled: wallet.selfAllocateEnabled !== false,
      });
    } catch (_err) {
      this.setState({ availableCredit: 0, selfAllocateEnabled: false });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const prevPath = prevProps.location?.pathname;
    const nextPath = this.props.location?.pathname;

    if (prevPath !== nextPath) {
      await this.populateTransaction();
      await this.populateNavigationPaths();
    }

    const isNewTransaction = !this.state.data.id && !this.state.data.transid;

    if (!isNewTransaction) return;

    if ((this.state.data.customer !== prevState.data.customer)) {
      await this.populateCustomerAccountList();
      this.updatePromotionPreview();
    }

    if ((this.state.data.account !== prevState.data.account) && !this.isUnsetValue(this.state.data.account)) {
      await this.populateAccountDetails(this.state.data.account);
    }

    if ((this.state.data.service !== prevState.data.service) && !this.isUnsetValue(this.state.data.service)) {
      await this.populateServiceDetails(this.state.data.service);
    }

    if ((this.state.data.quantity !== prevState.data.quantity)) {
      if (!this.isUnsetValue(this.state.data.quantity)) {
        this.populateTotalAmount(this.state.data.quantity);
      } else {
        this.setState({
          data: { ...this.state.data, amount: 0 },
          promotionPreview: null
        });
      }
    }

    if ((this.state.data.paymode !== prevState.data.paymode)) {
      this.populateConfirmedBy();
    }
  }

  async populateCustomerAccountList() {
    try {
      const response = await getCustomerAccounts();
      const payload = response?.data;
      const accounts = Array.isArray(payload) ? payload : (payload?.data || []);
      const customerAccountList = accounts
        .filter((account) => String(account.effective_billing_mode || 'prepaid') !== 'postpaid')
        .map((account) => {
        const accountlist = {};
        accountlist['id'] = account.id;
        accountlist['label'] = account.name + " [" + account.username + "]";
        accountlist['value'] = account.username;
        accountlist['accountId'] = account.id;
        return accountlist;
      })
      this.setState({ customerAccountList });
    } catch (error) {
      console.error('Error fetching customer accounts:', error);
      this.setState({ customerAccountList: [] });
    }
  }

  async populateAccountDetails(username) {
    if (this.isUnsetValue(username)) return;

    const { data: account } = await getAccount(username);

    let data = { ...this.state.data };
    data['service'] = account.srvid * 1;
    data['fullname'] = account.name;
    data['phone'] = account.phone;
    data['mobile'] = account.mobile;
    data['email'] = account.email;
    data['address'] = account.address;
    data['city'] = account.city;
    data['state'] = account.state;
    data['country'] = account.country;

    // Fetch service details to populate serviceList with name
    let serviceList = [...this.state.serviceList];
    if (account.srvid) {
      try {
        const { data: service } = await getService(account.srvid);
        const existingIndex = serviceList.findIndex(s => s.id === account.srvid);
        const serviceItem = { id: account.srvid, label: service?.name || String(account.srvid), value: account.srvid };

        if (existingIndex >= 0) {
          serviceList[existingIndex] = serviceItem;
        } else {
          serviceList.push(serviceItem);
        }
      } catch (e) {
        // If service fetch fails, add with ID as label
        const existingIndex = serviceList.findIndex(s => s.id === account.srvid);
        const serviceItem = { id: account.srvid, label: String(account.srvid), value: account.srvid };

        if (existingIndex >= 0) {
          serviceList[existingIndex] = serviceItem;
        } else {
          serviceList.push(serviceItem);
        }
      }
    }

    this.setState({ data, serviceList, selectedAccountId: account.id || null }, this.updatePromotionPreview);
  }

  handleRenewWithCredit = async () => {
    const accountId = this.state.selectedAccountId;
    const quantity = Number(this.state.data.quantity) || 0;
    const amount = Number(this.state.data.amount) || 0;
    if (!accountId) {
      toast.error("Select an account first.");
      return;
    }
    if (quantity < 1) {
      toast.error("Quantity must be at least 1.");
      return;
    }
    if (this.state.availableCredit < amount) {
      toast.error("Insufficient Available Credit for this renewal.");
      return;
    }
    this.setState({ renewingWithCredit: true });
    try {
      await renewAccountWithCredit(accountId, { quantity });
      toast.success("Renewed with Available Credit.");
      this.props.history.push(`/accounts/${this.state.data.account}`);
    } catch (ex) {
      toast.error(ex.response?.data?.message || ex.response?.data || "Could not renew with Available Credit.");
    } finally {
      this.setState({ renewingWithCredit: false });
    }
  };

  async populateServiceDetails(serviceId) {
    if (this.isUnsetValue(serviceId)) return;

    const { data: service } = await getService(serviceId);

    let data = { ...this.state.data };
    data['unitprice'] = service.unitprice * 1;
    

    this.setState({ data }, this.updatePromotionPreview);
  }

  populateTotalAmount(quantity) {
    let data = { ...this.state.data };

    data['amount'] = Number((parseFloat(this.state.data.unitprice) * quantity).toFixed(2));
    this.setState({ data }, this.updatePromotionPreview);
  }

  updatePromotionPreview = async () => {
    const { data } = this.state;
    const customerId = Number(data.customer);
    const serviceId = Number(data.service);
    const quantity = Number(data.quantity);
    const unitPrice = Number(data.unitprice);

    if (data.id || !customerId || !serviceId || !quantity || !unitPrice) {
      this.setState({ promotionPreview: null });
      return;
    }

    const originalPrice = Number((unitPrice * quantity).toFixed(2));
    if (!originalPrice || originalPrice <= 0) {
      this.setState({ promotionPreview: null });
      return;
    }

    try {
      const response = await getEligiblePromotions(customerId, serviceId, originalPrice);
      const { best, pricing } = response.data || {};

      if (!best || !pricing) {
        this.setState({
          data: { ...this.state.data, amount: originalPrice },
          promotionPreview: null
        });
        return;
      }

      const finalPrice = Number(parseFloat(pricing.finalPrice).toFixed(2));
      const discountAmount = Number(parseFloat(pricing.discountAmount).toFixed(2));

      this.setState({
        data: { ...this.state.data, amount: finalPrice },
        promotionPreview: {
          name: best.name,
          description: best.description,
          originalPrice,
          discountAmount,
          finalPrice
        }
      });
    } catch (error) {
      console.error('Error checking eligible promotions:', error);
      this.setState({ promotionPreview: null });
    }
  }

  renderPromotionPreviewComment() {
    const { promotionPreview } = this.state;
    if (!promotionPreview) return "";

    const formatCurrency = value =>
      `₦${value.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    return (
      <span>
        <strong>{promotionPreview.name}</strong>
        {promotionPreview.description ? ` - ${promotionPreview.description}` : ""}
        <br />Original: {formatCurrency(promotionPreview.originalPrice)}
        {", "}Discount: {formatCurrency(promotionPreview.discountAmount)}
        {", "}Final: {formatCurrency(promotionPreview.finalPrice)}
      </span>
    );
  }

  populateConfirmedBy() {
    if (this.state.data.id) {
      let data = { ...this.state.data };

      data['confirmedby'] = this.props.user.id;
      this.setState({ data });
    }
  }

  mapToViewModel(payment) {
    return {
      id: payment.id,
      customer: payment.customer,
      account: payment.account,
      accountId: payment.accountId || null,
      createdby: payment.createdby,
      confirmedby: payment.confirmedby,
      service: payment.service,
      quantity: payment.quantity,
      unitprice: payment.unitprice,
      amount: parseInt(payment.amount),
      comment: payment.comment,
      transid: payment.transid,
      fullname: payment.fullname,
      phone: payment.phone,
      mobile: payment.mobile,
      email: payment.email,
      address: payment.address,
      city: payment.city,
      state: payment.state,
      country: payment.country,
      invnum: payment.invnum,
      paymode: payment.paymode,
      status: payment.status,
      paid: payment.paid,
      remark: payment.remark,
      providerKey: payment.providerKey || '',
      providerReference: payment.providerReference || '',
    };
  }

  doSubmit = async () => {
    try {
      let data = this.state.data;

      // The renewal surface never persists a Transaction directly: creation
      // happens only at "Continue to <Provider>" inside CustomerPaymentModal.
      // There is no Save control in new-payment mode, so guard the implicit
      // form-submit path (e.g. Enter) from reaching savePayment.
      if (!data.id) return;

      // If mobile is empty, set it to phone
      if (!data.mobile || data.mobile.trim() === "") {
        data.mobile = data.phone;
      }      
      
      let result = await savePayment(data);

      // Extract subaccount code and split details from response if available (for new transactions with resellers)
      if (result.data.subaccountCode) {
        data.subaccountCode = result.data.subaccountCode;
        data.splitType = result.data.splitType;
        data.splitAmount = result.data.splitAmount;
        this.setState({ data });
      }
      data.providerKey = result.data.providerKey || data.providerKey || '';
      data.providerReference = result.data.providerReference || data.providerReference || '';
      this.setState({ data });

      if (result.data.id) {
        this.props.history.push(`/payments/${result.data.transid}`);
        this.populateTransaction();
      }

      // if (result.data.status === 0) {
      //   window.location.href = `./${result.data.transid}`;
      // } else {
      //   this.props.history.push("/payments");
      // }
  
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error("Error: " + ex.response.data);
      }
    }
  };

  render() {
    const isNew = !this.state.data.transid;
    const showWorkspace =
      !isNew &&
      this.state.viewMode !== "edit" &&
      !this.state.loadingRecord &&
      this.props.match.params.id !== "new";

    if (showWorkspace) {
      return (
        <Payment360Panel
          payment={this.state.data}
          history={this.props.history}
          location={this.props.location}
          navPaths={this.state.navPaths}
          providerPublicKey={this.state.paymentOptions.find((option) => option.providerKey === this.state.providerKey)?.publicKey || ''}
          onRefresh={(reference) => {
            this.props.history.replace(`/payments/${reference}`);
            this.populateTransaction();
          }}
          onSync={this.doRequeryTransaction}
        />
      );
    }

    const showRequery = (
      !!this.state.data.transid &&
      String(this.state.data.paymode) === '4'
    );
    const amount = Number(this.state.data.amount) || 0;
    const showRenewWithCredit =
      isNew &&
      this.state.selfAllocateEnabled &&
      this.state.selectedAccountId &&
      Number(this.state.data.quantity) >= 1 &&
      amount > 0 &&
      this.state.availableCredit >= amount;

    return (
      <React.Fragment>
        <form className="" onSubmit={this.handleSubmit}>
          {this.renderFormButtonBar(false, {
            rightButtons: (
              <>
                {isNew && this.state.selectedAccountId && (
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm ml-2"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ paymentModalOpen: true });
                    }}
                    disabled={this.state.renewingWithCredit || this.state.loadingRecord}
                  >
                    <i className="fa fa-money" />{" "}
                    <span className="d-none d-sm-inline">
                    Pay Now
                    </span>
                  </button>
                )}
                {showRequery && (
                  <button
                    type="button"
                    className="btn btn-light btn-sm ml-2"
                    onClick={(e) => {
                      e.preventDefault();
                      this.doRequeryTransaction();
                    }}
                    disabled={this.state.loadingRecord}
                  >
                    <i className="fa fa-refresh" /> <span className="d-none d-sm-inline">Sync</span>
                  </button>
                )}
              </>
            )
          })}

          <div className="form-input">
            <div className="d-flex justify-content-between align-items-center pt-2 pb-3">
              <h4 className="text-secondary m-0">
                {this.state.loadingRecord ? (
                  <>
                    <i className="animate-spin fa fa-spinner" /> Loading Payment
                  </>
                ) : (
                  this.state.title
                )}
              </h4>
              <RecordNavigation
                history={this.props.history}
                currentPath={this.props.location.pathname}
                paths={this.state.navPaths || []}
              />
            </div>
            {!this.state.loadingRecord && (
              <>
                {!!this.state.data.id && this.renderInput("transid", "Transaction ID", "", true)}
                {!!this.state.data.paid && this.renderInput("paid", "Payment Date", "datetime-local", true)}
                {this.renderSelect("account", "Account", this.state.customerAccountList, this.state.data.id)}
                {this.renderInput("email", "Email", "", true)}
                {this.renderSearchableSelect("service", "Service", this.state.serviceList, true, { onSearch: this.searchServices })}
                {this.renderInput("quantity", "Quantity", "number", this.state.data.id)}
                {this.renderCurrencyInput("unitprice", "Unitprice", true)}
                {this.renderCurrencyInput("amount", "Amount", true, this.renderPromotionPreviewComment())}
              </>
            )}
          </div>
        </form>
        {this.state.paymentModalOpen && (
          <CustomerPaymentModal
            accountId={this.state.selectedAccountId}
            quantity={Number(this.state.data.quantity) || 1}
            amount={Number(this.state.data.amount) || 0}
            title="Pay subscription"
            onClose={() => this.setState({ paymentModalOpen: false })}
            onPaid={() => {
              this.setState({ paymentModalOpen: false });
              this.props.history.push(`/accounts/${this.state.data.account}`);
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

export default PaymentForm;
